var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBill8851(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.275 12.5 c -0.761 0 -1.382 -0.674 -1.259 -1.429 C 0.695 6.885 4.31 3.69 8.668 3.69 h 6.342 l 6.771 8.81 H 1.275 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(222,222,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.553 77.5 V 60.435 V 12.5 c 0 -4.866 -3.925 -8.81 -8.767 -8.81 h 0 h 0 H 8.668 h 0 h 0 c 4.842 0 8.767 3.944 8.767 8.81 v 47.935 V 77.5 c 0 4.866 3.925 8.81 8.767 8.81 h 0 L 72.553 77.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(66,163,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.553 77.5 H 36.459 c -0.818 0 -1.474 0.618 -1.606 1.429 c -0.679 4.186 -4.294 7.381 -8.652 7.381 H 81.32 h 0 c 4.392 0 8.029 -3.245 8.667 -7.479 c 0.106 -0.704 -0.466 -1.331 -1.175 -1.331 L 72.553 77.5",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(222,222,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.77 45.471 h 32.595 c 0.853 0 1.545 -0.691 1.545 -1.545 s -0.692 -1.545 -1.545 -1.545 H 28.77 c -0.853 0 -1.545 0.691 -1.545 1.545 S 27.917 45.471 28.77 45.471 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(222,222,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.77 30.664 H 42.6 c -0.302 0 -0.557 -0.255 -0.557 -0.557 c 0 -0.853 -0.691 -1.545 -1.545 -1.545 c -0.853 0 -1.545 0.691 -1.545 1.545 c 0 2.011 1.636 3.647 3.647 3.647 h 0.54 v 1.059 c 0 0.853 0.691 1.545 1.545 1.545 s 1.545 -0.691 1.545 -1.545 v -1.059 h 0.54 c 2.01 0 3.647 -1.636 3.647 -3.647 v -3.235 c 0 -0.107 -0.011 -0.211 -0.032 -0.312 c -0.152 -1.759 -1.545 -3.151 -3.303 -3.303 c -0.101 -0.021 -0.205 -0.032 -0.312 -0.032 H 42.6 c -0.302 0 -0.557 -0.255 -0.557 -0.557 v -3.235 c 0 -0.302 0.255 -0.557 0.557 -0.557 h 4.17 c 0.302 0 0.557 0.255 0.557 0.557 c 0 0.853 0.692 1.545 1.545 1.545 s 1.545 -0.691 1.545 -1.545 c 0 -2.01 -1.636 -3.646 -3.647 -3.646 h -0.54 v -1.059 c 0 -0.853 -0.691 -1.545 -1.545 -1.545 s -1.545 0.691 -1.545 1.545 v 1.059 H 42.6 c -2.011 0 -3.647 1.636 -3.647 3.646 v 3.235 c 0 2.011 1.636 3.647 3.647 3.647 h 4.17 c 0.302 0 0.557 0.255 0.557 0.557 v 3.235 C 47.327 30.409 47.072 30.664 46.77 30.664 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(222,222,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.365 52.68 H 28.77 c -0.853 0 -1.545 0.692 -1.545 1.545 s 0.691 1.545 1.545 1.545 h 32.595 c 0.853 0 1.545 -0.692 1.545 -1.545 S 62.218 52.68 61.365 52.68 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(222,222,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.365 62.979 H 49.368 c -0.853 0 -1.545 0.692 -1.545 1.545 c 0 0.853 0.692 1.545 1.545 1.545 h 11.998 c 0.853 0 1.545 -0.692 1.545 -1.545 C 62.91 63.671 62.218 62.979 61.365 62.979 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(222,222,222)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill8851);
export default __webpack_public_path__ + "static/media/bill-8851.6c57adf9fe02544339d3a01340cc393f.svg";
export { ForwardRef as ReactComponent };